<template>
  <div class="px-2">
    <div v-if="!hasAward">
      <div>
        <img src="./assets/img/smell.png" alt="" width="32" />
      </div>
      <div>
        <span>感谢参与</span>
      </div>
    </div>
    <div v-else>
      <template v-if="isRed">
        <img src="/assets/img/award/lottery-red.jpeg" width="32" alt=""/>
        <div class="truncate">
          {{ item.amount }}元红包
        </div>
      </template>
      <template v-else >
        <div :class="{'empty-img-box': !awardImg}">
          <div v-if="awardImg" :style="{backgroundImage:`url(${awardImg})`}" class="award-img-box">
<!--            <img :src="awardImg"  height="32"/>-->
          </div>
          <div class="truncate">
            {{ awardName }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { convertDownloadUrl } from 'dygc'

export default {
  name: 'LuckGridItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hasAward() {
      return this.item.hasAward
    },
    awardName() {
      return this.item.awardName
    },
    awardImg() {
      let url = this.item.awardImg
      if (!url) return ''
      if(url.startsWith('http')) return url
      return convertDownloadUrl(url)
    },
    isRed() {
      return this.item.lotteryCategory === 4
    }
  }
}
</script>

<style scoped>
.empty-img-box {
   padding-top: 20px;
}
.award-img-box {
  height: 36px;
  width: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  margin-bottom: 4px;
}
</style>